import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PostCreator from '../news-feed/components/PostCreator';
import { postService } from '../../lib/postService';
import ChatOverlay from './components/ChatOverlay';
import Logo from '../../components/Logo';

export default function Salon() {
  const navigate = useNavigate();
  const [activeMember, setActiveMember] = useState(null);
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const fetchedPosts = await postService.getPosts();
        setPosts(fetchedPosts);
      } catch (err) {
        setPosts([]);
      }
    };
    fetchPosts();

    const subscription = postService.subscribeToPosts(() => {
      fetchPosts();
    });

    return () => {
      if (subscription && subscription.unsubscribe) {
        subscription.unsubscribe();
      }
    };
  }, []);

  const salonMembers = [
    { id: 1, name: 'Dr. Elena Rostova', role: 'Aerospace AI Engineer', avatar: 'https://images.unsplash.com/photo-1580894732444-8ecded7900cd?w=150&h=150&fit=crop', isElite: true },
    { id: 2, name: 'Marcus Chen', role: 'Orbital Architect', avatar: 'https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=150&h=150&fit=crop', isElite: true },
    { id: 3, name: 'Sarah Jenkins', role: 'Military Tech Historian', avatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=150&h=150&fit=crop' },
  ];

  return (
    <div className="min-h-screen text-aether-light font-sans relative overflow-x-hidden" style={{ backgroundColor: '#0e0e0e' }}>
      {/* Background Effect */}
      <div className="fixed inset-0 pointer-events-none z-[-1]" style={{ background: 'radial-gradient(circle at 50% 120%, rgba(255, 255, 255, 0.08) 0%, rgba(0, 0, 0, 1) 70%)' }}>
        <div className="absolute bottom-[-50vh] left-0 w-full h-screen sunrise-glow mix-blend-screen opacity-40 pointer-events-none" style={{ background: 'radial-gradient(ellipse at center, rgba(255, 255, 255, 0.05) 0%, transparent 80%)' }}></div>
      </div>

      {/* Top Navbar */}
      <nav className="fixed top-0 w-full glass-panel z-40 border-b border-[rgba(255,255,255,0.1)]">
        <div className="max-w-7xl mx-auto px-4 h-16 flex items-center justify-between">
          <div className="flex items-center gap-8">
            <Logo />
            <div className="hidden md:flex items-center gap-6 text-sm font-light uppercase tracking-widest">
              <span className="cursor-pointer hover:text-aether-gold transition-colors" onClick={() => navigate('/curation')}>Curation</span>
              <span className="cursor-pointer hover:text-aether-gold transition-colors" onClick={() => navigate('/')}>Feed</span>
              <span className="cursor-pointer text-aether-gold border-b border-aether-gold pb-1" onClick={() => navigate('/salon')}>Salon</span>
            </div>
          </div>
          <div className="flex items-center gap-4">
            <span className="material-symbols-outlined cursor-pointer hover:text-aether-gold transition-colors">notifications</span>
            <span className="material-symbols-outlined cursor-pointer hover:text-aether-gold transition-colors">person</span>
          </div>
        </div>
      </nav>

      {/* Main Layout */}
      <div className="max-w-7xl mx-auto pt-24 px-4 pb-12 flex gap-8 relative z-10">
        
        {/* Left Sidebar */}
        <div className="hidden lg:block w-64 flex-shrink-0 space-y-8">
          <div className="glass-panel p-6 rounded-2xl border border-[rgba(255,255,255,0.05)]">
            <ul className="space-y-4 text-sm font-light">
              <li className="flex items-center gap-3 cursor-pointer hover:text-aether-gold transition-colors" onClick={() => navigate('/')}>
                <span className="material-symbols-outlined text-lg">home</span> Feed
              </li>
              <li className="flex items-center gap-3 cursor-pointer hover:text-aether-gold transition-colors" onClick={() => navigate('/curation')}>
                <span className="material-symbols-outlined text-lg">explore</span> Curation
              </li>
              <li className="flex items-center gap-3 cursor-pointer text-aether-gold" onClick={() => navigate('/salon')}>
                <span className="material-symbols-outlined text-lg">groups</span> Salon
              </li>
              <li className="flex items-center gap-3 cursor-pointer hover:text-[#00ffcc] transition-colors mt-2 pt-2 border-t border-[rgba(255,255,255,0.05)] text-[#00ffcc]" onClick={() => navigate('/gaming')}>
                <span className="material-symbols-outlined text-lg">sports_esports</span> Game News
              </li>
              <li className="flex items-center gap-3 cursor-pointer hover:text-aether-gold transition-colors mt-2 pt-2 border-t border-[rgba(255,255,255,0.05)] text-aether-light" onClick={() => navigate('/architecture')}>
                <span className="material-symbols-outlined text-lg">domain</span> Architecture
              </li>
              <li className="flex items-center gap-3 cursor-pointer hover:text-aether-gold transition-colors mt-2 pt-2 border-t border-[rgba(255,255,255,0.05)] text-[#d4af37]" onClick={() => navigate('/contracts')}>
                <span className="material-symbols-outlined text-lg">work</span> Contracts
              </li>
            </ul>
          </div>
        </div>

        {/* Main Feed */}
        <div className="flex-1 max-w-2xl space-y-8">
          
          <div className="text-center mb-10">
            <h2 className="font-playfair text-3xl text-aether-gold mb-2">The Inner Salon</h2>
            <p className="text-sm text-aether-light/60 font-light tracking-widest uppercase">Exclusive Members-Only Circle</p>
          </div>

          {/* Post Creator */}
          <div className="glass-panel p-1 rounded-2xl border border-[rgba(255,255,255,0.05)] mb-8 relative">
             <div className="absolute -top-3 -right-3 w-8 h-8 rounded-full flex items-center justify-center shadow-lg" style={{ background: 'linear-gradient(135deg, #d4af37, #aa8222)' }}>
                <span className="material-symbols-outlined text-[16px] text-black" style={{ fontVariationSettings: "'FILL' 1" }}>lock</span>
             </div>
             <PostCreator />
          </div>

          {/* Posts Feed */}
          <div className="space-y-6">
            {posts && posts.length > 0 ? (
              posts.map((post, idx) => (
                <div key={post.id || idx} className="glass-panel p-6 rounded-2xl border border-[rgba(255,255,255,0.05)] space-y-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3">
                      <div className="w-10 h-10 rounded-full bg-[rgba(255,255,255,0.1)] flex items-center justify-center overflow-hidden">
                        {post.author?.avatar_url ? (
                          <img src={post.author.avatar_url} alt="author avatar" className="w-full h-full object-cover" />
                        ) : (
                          <span className="material-symbols-outlined text-sm">person</span>
                        )}
                      </div>
                      <div>
                        <h4 className="font-playfair text-aether-light flex items-center gap-1">
                          {post.author?.full_name || post.author?.username || 'Anonymous'}
                          {post.author?.isElite && (
                            <span className="material-symbols-outlined text-[14px]" style={{ color: '#d4af37', fontVariationSettings: "'FILL' 1" }}>verified</span>
                          )}
                        </h4>
                        <span className="text-xs text-aether-light/50">
                          {post.created_at ? new Date(post.created_at).toLocaleDateString() : 'Just now'}
                        </span>
                      </div>
                    </div>
                  </div>
                  <p className="font-light text-sm text-aether-light/80 leading-relaxed">
                    {post.content || post.text}
                  </p>
                  {post.image_url && (
                    <div className="mt-4 rounded-xl overflow-hidden border border-[rgba(255,255,255,0.05)]">
                      <img src={post.image_url} alt="Post content" className="w-full h-auto" />
                    </div>
                  )}
                  {post.video_url && (
                    <div className="mt-4 rounded-xl overflow-hidden border border-[rgba(255,255,255,0.05)] bg-black">
                      <video src={post.video_url} controls className="w-full h-auto max-h-[500px]" />
                    </div>
                  )}
                </div>
              ))
            ) : (
              <div className="text-center py-12 text-aether-light/50 font-light">
                No posts available yet. Be the first to share in the Salon!
              </div>
            )}
          </div>
        </div>

        {/* Right Sidebar */}
        <div className="hidden xl:block w-80 flex-shrink-0 space-y-8">
          {/* Current Curation */}
          <div className="glass-panel p-6 rounded-2xl border border-[rgba(255,255,255,0.05)]">
            <h3 className="font-playfair text-aether-gold text-sm tracking-widest uppercase mb-4">Current Curation</h3>
            <div className="aspect-video rounded-lg mb-3 flex items-center justify-center border border-[rgba(255,255,255,0.05)] overflow-hidden">
              <img src="https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=500&h=300&fit=crop" alt="Space Architecture" className="w-full h-full object-cover" />
            </div>
            <h4 className="font-playfair text-lg text-aether-light mb-1">AI & Orbital Architecture</h4>
            <p className="text-xs font-light text-aether-light/60">Engineering the Void: High-tech aerospace concepts.</p>
          </div>

          {/* Salon Members */}
          <div className="glass-panel p-6 rounded-2xl border border-[rgba(255,255,255,0.05)]">
            <h3 className="font-playfair text-aether-gold text-sm tracking-widest uppercase mb-4">Salon Members</h3>
            <div className="space-y-4">
              {salonMembers.map((member) => (
                <div 
                  key={member.id} 
                  className="flex items-center justify-between cursor-pointer group"
                  onClick={() => setActiveMember(member)}
                >
                  <div className="flex items-center gap-3">
                    <img src={member.avatar} alt={member.name} className="w-8 h-8 rounded-full border border-[rgba(255,255,255,0.1)] group-hover:border-aether-gold transition-colors" />
                    <div>
                      <p className="text-sm font-light text-aether-light group-hover:text-aether-gold transition-colors flex items-center gap-1">
                        {member.name}
                        {member.isElite && <span className="material-symbols-outlined text-[12px]" style={{ color: '#d4af37', fontVariationSettings: "'FILL' 1" }}>verified</span>}
                      </p>
                      <p className="text-[10px] text-aether-light/50 uppercase tracking-wider">{member.role}</p>
                    </div>
                  </div>
                  <span className="material-symbols-outlined text-sm text-aether-light/30 group-hover:text-aether-gold transition-colors">chat_bubble</span>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>

      {/* Chat Overlay */}
      <ChatOverlay activeMember={activeMember} onClose={() => setActiveMember(null)} />

    </div>
  );
}
